'use strict';

import('./js/exercises_category_filter.js');
import('./js/exercises_items.js');
import('./js/exercise_modal.js');
import('./js/footer.js');
import('./js/quote.js');
import('./js/mobile_menu.js');
import('./js/rating_modal.js');
import('./js/scroll_up.js');
import('./js/header.js');
